import gql from 'graphql-tag';
import { apolloClient as apollo } from '@/vue-apollo';
import * as _ from 'lodash';

export const myContract = async () => {
	try {
		const { data } = await apollo.query({
			query: gql`
				query {
					MyContract {
						${columns}
					}
				}
			`,
			variables: {},
			fetchPolicy: 'no-cache'
		});

		return data.MyContract;
	} catch (e) {
		console.log({ e });
	}
};

export const myContracts = async () => {
	//console.log("in crud myContracts " );
	try {
		const { data } = await apollo.query({
			query: gql`
				query {
					MyContracts {
						${columns}
					}
				}
			`,
			variables: {},
			fetchPolicy: 'no-cache'
		});

		return data.MyContracts;
	} catch (e) {
		console.log({ e });
	}
};

export const getContractTemplate = async (departmentNumber = 0, functionNumber = 0) => {
	const {
		data: { GetContractTemplate }
	} = await apollo.query({
		query: gql`
			query ($departmentNumber: Int!, $functionNumber: Int!) {
				GetContractTemplate(DepartmentNumber: $departmentNumber, FunctionNumber: $functionNumber) {
					${contractTemplateColumns}
				}
			}
		`,
		variables: {
			departmentNumber: parseInt(departmentNumber, 10),
			functionNumber: parseInt(functionNumber, 10)
		},
		fetchPolicy: 'no-cache'
	});

	return GetContractTemplate;
};

export const addUpdContractTemplate = async (newContractTemplate = {}) => {
	const mutation = gql`
		mutation ADD_UPD_CONTRACT_TEMPLATE($newContractTemplate: ContractTemplateInput!) {
			addUpdContractTemplate(NewContractTemplate: $newContractTemplate)
		}
	`;

	const {
		data: { addUpdContractTemplate }
	} = await apollo.mutate({
		mutation,
		variables: {
			newContractTemplate
		},
		fetchPolicy: 'no-cache'
	});

	return addUpdContractTemplate;
};

export const contracts = async (userId = 0) => {
	const {
		data: { Contracts }
	} = await apollo.query({
		query: gql`
			query ($userId: ID!) {
				Contracts(UserId: $userId) {
					${columns}
				}
			}
		`,
		variables: {
			userId: parseInt(userId, 10)
		},
		fetchPolicy: 'no-cache'
	});

	return Contracts;
};

export const dataCcn2642 = async (timeManagementType, refSalary, workSixDay = null) => {
	const mutation = gql`
		mutation ($workSixDay: ID, $timeManagementType: ID!, $refSalary: Float!) {
			ChangeTimeManagement(WorkSixDay: $workSixDay, TimeManagementType: $timeManagementType, RefSalary: $refSalary) {
				hourlyRate
				dailyRate
				totMinPerDay
				totMinPerDayStr
				weeklyFiveDayMinmumSalary
				weeklyFiveDaysRefSalary
				totMinPerWeek
				totMinPerWeekStr
				monthlyRate
				cdiMonthlyReferenceSalary
			}
		}
	`;

	let variables = {
		timeManagementType: +timeManagementType,
		refSalary: +refSalary
	};

	if (workSixDay && +workSixDay > 0) {
		variables = {
			...variables,
			workSixDay: +workSixDay
		};
	}

	const {
		data: { ChangeTimeManagement }
	} = await apollo.mutate({
		mutation,
		variables,
		fetchPolicy: 'no-cache'
	});

	return ChangeTimeManagement;
};

const columns = `
	id
	startDate
	endDate
	dailyRate
	overtimeRate
	nightTimeRate
	kmRate
	hourlyRate
	nightTimeStart
	nightTimeEnd
	totMinPerDay
	totMinPerWeek
	departmentName
	functionName
	hotelPerDiem
	dailyRightTransfer
	defaultDayType
	lunchPerDiem
	lunchMinimum
	travelDailyRate
	sixthDay
	seventhDay
	daysForeseen
	hourBeforeTimeRate
	minTimeBetweenDays
	totMinPerDayStr
	totMinPerWeekStr
	department
	function
	timeManagementType
	weeklyOvertime
	workSixDays
	weeklyFiveDaysMinimumSalary
	weeklySixDaysMinimumSalary
	weeklyFiveDaysEffNumHours
	weeklyFiveDaysEquNumHours
	weeklySixDaysEffNumHours
	weeklySixDaysEquNumHours
	weeklyBonusAmount
	weeklyFiveDaysRefSalary
	weeklySixDaysRefSalary
	weeklyOvtOneLimit
	weeklyOvtOneRate
	weeklyOvtTwoLimit
	weeklyOvtTwoRate
	weeklyOvtThreeLimit
	weeklyOvtThreeRate
	weeklyBaseEffNumHours
	hourlyRateAnnexThree
	weeklyBonusAmountFiveDays
	weeklyBonusAmountSixDays
	weeklyBaseRefSalary
	weeklyBaseMinimumSalary
	weeklyFiveDaysMinimumSalaryAnThree
	weeklySixDaysMinimumSalaryAnThree
	transportRate
	transportPaidAfter
	ovtLimit1
	ovtLimit2
	ovtRate1
	ovtRate2
	sundayPublicHolidayFactor
	companyCostFactor
	minTimeBetweenWeek
	transportPaidAfterStr
	ovtLimit1Str
	ovtLimit2Str
	minTimeBetweenWeekStr
	totMinPerDayForContDay
	lunchMinimumForContDay
	totMinPerDayForContDayStr
	weeklyBaseEffNumHoursStr
	weeklyOvtOneLimitStr
	weeklyOvtTwoLimitStr
	weeklyOvtThreeLimitStr
	lunchMinimumStr
	lunchMinimumForContDayStr
	employeeStatus
	isAutomaticSentContract
	costCenterPrepsType
	costCenterShootingType
	costCenterWrapType
	documentPackageId
	useCarAllowance
	carAllowanceRate
	carAllowance
	useProductionFeeAllowance
	productionFeeAllowanceRate
	productionFeeAllowance
	useDinnerPerDiem
	dinnerPerDiem
	useComputerAllowance
	computerAllowanceRate
	computerAllowance
	minimumHourGuaranteed
	minimumHourGuaranteedType
	minimumHourGuaranteedStr
	beforeCallTimeRate
	ifWorkAboveDailyHours
	usePhoneAllowance
	phoneAllowanceRate
	phoneAllowance
	useBoxKitAllowance
	boxKitAllowanceRate
	boxKitAllowance
	useAbroadPerDiem
	abroadPerDiem
	useHotelPerDiem
	useLunchPerDiem
	note
	weeklyFiveDaysEffNumHoursStr
	weeklyFiveDaysEquNumHoursStr
	weeklySixDaysEffNumHoursStr
	weeklySixDaysEquNumHoursStr
	contractReference
	contractType
	dailyOvertime
	ovtLimit
	ovtLimitContinuousDay
	ovtLimitStr
	ovtLimitContinuousDayStr
	monthlyRate
	useTravelDailyRate
	baseSalary1PayCode
	baseSalary2PayCode
	baseSalary3PayCode
	baseSalary4PayCode
	dayOvt1PayCode
	dayOvt2PayCode
	dayOvt3PayCode
	weekOvt1PayCode
	weekOvt2PayCode
	weekOvt3PayCode
	nightTimePayCode
	restPayCode
	transportPayCode
	sundayPayCode
	seventhDayPayCode
	sixthDayPayCode
	beforeTimePayCode
	travelAllowancePayCode
	carAllowancePayCode
	phoneAllowancePayCode
	computerAllowancePayCode
	boxKitAllowancePayCode
	productionFeeAllowancePayCode
	lunchPerDiemPayCode
	dinerPerDiemPayCode
	hotelPerDiemPayCode
	abroadPerDiemPayCode
	collectiveAgreement
	echelon
	analyticCode
	cdiMonthlyReferenceSalary
	publicHolidayCalendar
`;

const contractTemplateColumns = `
	defaultDayType
	dailyRate
	travelDailyRate
	hourlyRate
	overtimeRate
	nightTimeRate
	hourBeforeTimeRate
	kmRate
	lunchPerDiem
	hotelPerDiem
	dailyRightTransfer
	nightTimeStart
	nightTimeEnd
	minTimeBetweenDays
	lunchMinimum
	totMinPerDay
	totMinPerWeek
	sixthDay
	seventhDay
	timeManagementType
	weeklyOvertime
	workSixDays
	weeklyFiveDaysMinimumSalary
	weeklySixDaysMinimumSalary
	weeklyFiveDaysEffNumHours
	weeklyFiveDaysEquNumHours
	weeklySixDaysEffNumHours
	weeklySixDaysEquNumHours
	weeklyBonusAmount
	weeklyFiveDaysRefSalary
	weeklySixDaysRefSalary
	weeklyOvtOneLimit
	weeklyOvtOneRate
	weeklyOvtTwoLimit
	weeklyOvtTwoRate
	weeklyOvtThreeLimit
	weeklyOvtThreeRate
	weeklyBaseEffNumHours
	hourlyRateAnnexThree
	weeklyBonusAmountFiveDays
	weeklyBonusAmountSixDays
	weeklyBaseRefSalary
	weeklyBaseMinimumSalary
	weeklyFiveDaysMinimumSalaryAnThree
	weeklySixDaysMinimumSalaryAnThree
	transportRate
	transportPaidAfter
	ovtLimit1
	ovtLimit2
	ovtRate1
	ovtRate2
	sundayPublicHolidayFactor
	companyCostFactor
	minTimeBetweenWeek
	transportPaidAfterStr
	ovtLimit1Str
	ovtLimit2Str
	minTimeBetweenWeekStr
	totMinPerDayStr
	totMinPerWeekStr
	totMinPerDayForContDay
	lunchMinimumForContDay
	totMinPerDayForContDayStr
	weeklyBaseEffNumHoursStr
	weeklyOvtOneLimitStr
	weeklyOvtTwoLimitStr
	weeklyOvtThreeLimitStr
	lunchMinimumStr
	lunchMinimumForContDayStr
	employeeStatus
	isAutomaticSentContract
	costCenterPrepsType
	costCenterShootingType
	costCenterWrapType
	documentPackageId
	useCarAllowance
	carAllowanceRate
	carAllowance
	useProductionFeeAllowance
	productionFeeAllowanceRate
	productionFeeAllowance
	useDinnerPerDiem
	dinnerPerDiem
	useComputerAllowance
	computerAllowanceRate
	computerAllowance
	minimumHourGuaranteed
	minimumHourGuaranteedType
	minimumHourGuaranteedStr
	beforeCallTimeRate
	ifWorkAboveDailyHours
	usePhoneAllowance
	phoneAllowanceRate
	phoneAllowance
	useBoxKitAllowance
	boxKitAllowanceRate
	boxKitAllowance
	useAbroadPerDiem
	abroadPerDiem
	useHotelPerDiem
	useLunchPerDiem
	note
	weeklyFiveDaysEffNumHoursStr
	weeklyFiveDaysEquNumHoursStr
	weeklySixDaysEffNumHoursStr
	weeklySixDaysEquNumHoursStr
	contractReference
	contractType
	dailyOvertime
	ovtLimit
	ovtLimitContinuousDay
	ovtLimitStr
	ovtLimitContinuousDayStr
	monthlyRate
	useTravelDailyRate
	baseSalary1PayCode
	baseSalary2PayCode
	baseSalary3PayCode
	baseSalary4PayCode
	dayOvt1PayCode
	dayOvt2PayCode
	dayOvt3PayCode
	weekOvt1PayCode
	weekOvt2PayCode
	weekOvt3PayCode
	nightTimePayCode
	restPayCode
	transportPayCode
	sundayPayCode
	seventhDayPayCode
	sixthDayPayCode
	beforeTimePayCode
	travelAllowancePayCode
	carAllowancePayCode
	phoneAllowancePayCode
	computerAllowancePayCode
	boxKitAllowancePayCode
	productionFeeAllowancePayCode
	lunchPerDiemPayCode
	dinerPerDiemPayCode
	hotelPerDiemPayCode
	abroadPerDiemPayCode
	collectiveAgreement
	echelon
	analyticCode
	cdiMonthlyReferenceSalary
	publicHolidayCalendar
`;
